import { Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';
import {
  ItemTitle,
  IconWrapper,
} from './styles';

import {
  WatchIcon,
} from '../../icons';

interface ComponentProps {
  DEV_ID: string|null,
  SCHEDULES_ACTIVE_QUANTITY: number
  SCHEDULE_TOTAL_QUANTITY: number
  handleOnClick
  CTRLOPER?: string | null
  SETPOINT?: number | null
  marginTopNumber?: number
}

export const ScheduleButton = (props: ComponentProps): JSX.Element => {
  const { t } = useTranslation();
  const twoDigits = props.SCHEDULES_ACTIVE_QUANTITY >= 10;

  const dutControlOperation = [
    { label: t('desabilitado'), value: '0_NO_CONTROL' },
    { label: t('modoEco'), value: '1_CONTROL' },
    { label: t('modoSobDemanda'), value: '2_SOB_DEMANDA' },
    { label: t('modoBackup'), value: '3_BACKUP' },
    { label: t('modoBloqueio'), value: '4_BLOCKED' },
    { label: t('modoBackupEco'), value: '5_BACKUP_CONTROL' },
    { label: t('modoEco2'), value: '6_BACKUP_CONTROL_V2' },
    { label: t('modoForcado'), value: '7_FORCED' },
    { label: t('modoEco2'), value: '8_ECO_2' },
  ];

  const ctrlLabel = props.CTRLOPER
    ? dutControlOperation.find((x) => x.value === props.CTRLOPER)?.label ?? props.CTRLOPER
    : null;

  const hasTemp = ctrlLabel != null;

  return (
    <>
      <Flex
        flexWrap="nowrap"
        flexDirection="row"
        width="255px"
        alignItems="center"
        mt={2}
        mr={0}
        style={{
          border: '1px solid lightgrey',
          borderRadius: '7px',
          cursor: 'pointer',
          minHeight: '48px',
          paddingTop: '4px',
          paddingBottom: '4px',
        }}
        onClick={() => props.handleOnClick()}
      >
        <div style={{ marginLeft: '11px' }}>
          <IconWrapper>
            <WatchIcon />
          </IconWrapper>
        </div>
        <div style={{
          marginLeft: '10px',
          color: '#5B5B5B',
          width: '188px',
        }}
        >
          <ItemTitle>
            Checar Programações
          </ItemTitle>
          {hasTemp && (
            <div style={{ fontSize: '11px', color: '#8C8C8C', lineHeight: '16px' }}>
              {ctrlLabel}
              {props.SETPOINT != null && ` · ${props.SETPOINT}°C`}
            </div>
          )}
        </div>
        {props.SCHEDULE_TOTAL_QUANTITY > 2 && (
          <div style={{
            marginLeft: '0px',
            marginTop: '-10px',
            marginRight: '-12px',
            color: '#FFFFFF',
            backgroundColor: '#363BC4',
            width: '20px',
            height: '20px',
            borderRadius: '10px',
          }}
          >
            <div style={{
              marginLeft: !twoDigits ? '7px' : '3px',
              marginTop: props.marginTopNumber ? `${props.marginTopNumber}px` : '-4px',
              fontSize: '11px',
            }}
            >
              {props.SCHEDULES_ACTIVE_QUANTITY}
            </div>
          </div>
        )}
      </Flex>
    </>
  );
};
